<template>
    <div>
        <v-container>
            <v-layout row justify-center>
            <v-flex xs12>
                <imagenes/>
            </v-flex>
        </v-layout>
        </v-container>
    </div>
</template>

<style>

</style>

<script>
import imagenes from '../components/Gallery/imagenes'
export default {
    data (){
        return {

        }
    },
    components:{
        imagenes
    }
}
</script>